import { useState as d, useCallback as c, useMemo as L, useRef as f, useEffect as b, useLayoutEffect as I } from "react";
import { getPopupPosition as x } from "./utils.js";
const v = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  width: 0,
  height: 0
};
function N({
  hover: e,
  position: r,
  closeDelay: u,
  boundingElementRef: n,
  enabled: o
}) {
  const [t, s] = d(!1), [i, p] = d(v), [m, h] = d(v), l = c(() => s(!0), []), a = c(() => s(!1), []), M = (n == null ? void 0 : n.current) || document.body, C = c(
    (E) => {
      const O = x(r, {
        anchor: i,
        popup: E,
        boundingRect: M.getBoundingClientRect()
      });
      h({ ...E, ...O });
    },
    [r, i, M]
  ), k = S(p), {
    onMouseEnterAnchor: P,
    onMouseLeaveAnchor: g,
    onMouseEnterPopup: w,
    onMouseLeavePopup: A
  } = B({
    openPopup: l,
    closePopup: a,
    closeDelay: u
  }), D = L(() => e ? {
    onClick: t ? a : l,
    onMouseEnter: P,
    onMouseLeave: g
  } : {
    onClick: t ? a : l
  }, [
    e,
    P,
    g,
    l,
    a,
    t
  ]), T = L(() => e ? {
    onMouseEnter: w,
    onMouseLeave: A
  } : {}, [e, w, A]);
  return {
    openPopup: l,
    closePopup: a,
    isOpen: o && t,
    anchor: i,
    popup: m,
    setPopupDimensions: C,
    anchorRef: k,
    anchorProps: D,
    popupProps: T
  };
}
function B({ openPopup: e, closePopup: r, closeDelay: u }) {
  const n = f(!1), o = f(!1), t = f(null), s = c(() => {
    clearTimeout(t.current), t.current = setTimeout(() => {
      !n.current && !o.current && r();
    }, u);
  }, [u, r]), i = c(() => {
    e(), n.current = !0;
  }, [e]), p = c(() => {
    n.current = !1, s();
  }, [s]), m = c(() => {
    o.current = !0;
  }, []), h = c(() => {
    o.current = !1, s();
  }, [s]);
  return {
    onMouseEnterAnchor: i,
    onMouseLeaveAnchor: p,
    onMouseEnterPopup: m,
    onMouseLeavePopup: h
  };
}
function q({
  isOpen: e,
  closePopup: r,
  closeOnPopupClick: u,
  popupRef: n
}) {
  const o = c(
    (t) => {
      var s;
      (u || !(t.target instanceof Node && ((s = n.current) != null && s.contains(t.target)))) && r();
    },
    [u, n, r]
  );
  b(() => {
    const t = setTimeout(() => {
      e ? window.addEventListener("click", o) : window.removeEventListener("click", o);
    }, 0);
    return () => {
      clearTimeout(t), window.removeEventListener("click", o);
    };
  }, [e, o]);
}
function S(e) {
  const r = f(null), u = j(r), { height: n, width: o, left: t, top: s, right: i, bottom: p } = u;
  return I(() => {
    r.current && e({
      height: n,
      width: o,
      left: t,
      top: s,
      right: i,
      bottom: p
    });
  }, [e, n, o, t, s, p, i]), r;
}
function j(e) {
  return !e || !e.current ? {
    height: 0,
    width: 0,
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  } : e.current.getBoundingClientRect();
}
export {
  q as useAutoCloseOnClick,
  N as useContextPopupState,
  S as useElementDimensions
};
